// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.config-group div.text-error[data-v-589e6f3e] {\n    color: #fc4a40 !important;\n    padding: 0;\n    position: static;\n    border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
